// extracted by mini-css-extract-plugin
module.exports = {"heading":"style_heading__0QDXG","amountsGroup":"style_amountsGroup__QNhYz","groupDivider":"style_groupDivider__SskML"};